import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  Dropdown, DropdownMenu, DropdownItem, DropdownToggle,
} from 'reactstrap';
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons'

import { ModalManagerContext } from '../../ModalsManager';
import ContactUsModal from './ContactUsModal';
import useStyles from './styles';
import { logoImage } from '../../../config';
import { AuthUserContext } from '../Session';
import customerSuccessIcon from '../../../resources/undraw_Chat_bot_re_e2gj.svg'
import contactUsIcon from '../../../resources/undraw_Mobile_re_q4nk.svg'
import { showCustomerSuccess, customerSuccessUrl } from '../../../config';


const BaseContainer = ({ children }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [avatarError, setAvatarError] = useState(false);
  const openModal = useContext(ModalManagerContext);
  const { t } = useTranslation(['translation', 'COMMON'])

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const classes = useStyles();

  const handleCustomerSuccessClick = () => {
    if (customerSuccessUrl) {
      window.open(customerSuccessUrl);
    }
  }

  return (
    <AuthUserContext.Consumer>
      {({ avatar }) => {
        const Avatar = !avatarError && avatar
          ? <img 
              src={avatar} 
              className={classes.avatar} 
              alt="avatar menu" 
              onError={() => setAvatarError(true)}
            />
          : <FontAwesomeIcon
              icon={faUserCircle}
              style={{
                fontSize: '36px',
                cursor: 'pointer'
              }}
            />
        return (
          <>
            <div className={classes.logoContainer}>
              <img className={classes.logo} src={logoImage} alt="logo" />
              <div className={classes.rightPanel}>
                {showCustomerSuccess && (
                  <div className={classes.customerSuccessWrapper}>
                    <img
                      src={customerSuccessIcon}
                      className={classes.customerSuccessImage}
                      alt="customer-success"
                      onClick={handleCustomerSuccessClick}
                    />
                    <div className={classes.customerSuccessInfo}>
                      {t('COMMON.MENU.CUSTOMER_SUCCESS_PASSWORD')}
                    </div>
                  </div>
                )}
                <Dropdown
                  direction="left"
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  className={classes.profile}
                >
                  <DropdownToggle
                    tag="div"
                    data-toggle="dropdown"
                    aria-expanded={dropdownOpen}
                  >
                    {Avatar}
                  </DropdownToggle>
                  <DropdownMenu>
                    {/* <DropdownItem tag={NavLink} to="/user" className={classes.link}>
                    Usuario
                  </DropdownItem> */}
                    {/* <DropdownItem tag={NavLink} to="/brand/edit" className={classes.link}>
                    {t('COMMON.MENU.EDIT_BRAND')}
                  </DropdownItem> */}
                    <DropdownItem tag={NavLink} to="/logout" className={classes.link}>
                      {t('COMMON.MENU.LOG_OUT')}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <img
                  src={contactUsIcon}
                  alt="contact-us"
                  className={classes.contactUsImage}
                  onClick={() => openModal(ContactUsModal)}
                />
              </div>
            </div>
            <div className={classes.mainContentContainer}>
              {children}
            </div>
          </>
        )
      }}
    </AuthUserContext.Consumer>
  );
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BaseContainer;
